import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleBtn", "knob", "lightPhone", "darkPhone"]

  connect() {
    this.isDark = false
  }

  toggle() {
    this.isDark = !this.isDark

    if (this.isDark) {
      this.knobTarget.style.transform = "translateX(20px)"
      this.toggleBtnTarget.style.background = "#1B3A5C"

      this.lightPhoneTarget.style.opacity = "0.7"
      this.lightPhoneTarget.style.transform = "scale(0.95)"
      this.darkPhoneTarget.style.opacity = "1"
      this.darkPhoneTarget.style.transform = "scale(1)"
    } else {
      this.knobTarget.style.transform = "translateX(0)"
      this.toggleBtnTarget.style.background = "var(--ocean)"

      this.lightPhoneTarget.style.opacity = "1"
      this.lightPhoneTarget.style.transform = "scale(1)"
      this.darkPhoneTarget.style.opacity = "0.7"
      this.darkPhoneTarget.style.transform = "scale(0.95)"
    }
  }
}
